// extracted by mini-css-extract-plugin
export default {"parentLink":"NavAccordion_parentLink__VZVZS","childLink":"NavAccordion_childLink__YIT+d"};